import { React, useState, useEffect } from "react"

import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"

import { TabStrip, TabStripTab } from "@progress/kendo-react-layout"
import Form from "./Form"
import NwecHolbaRegistrationForm from './NwecHolbaRegistrationForm'

import { Button } from "@progress/kendo-react-buttons"

import {
  fetchAdminUsers,
  fetchUserGroups,
  submitOfficers
} from "../../Shared/Services/ApiService"

export default function NominateOfficers(props) {
  const { setAppBarTitle, backgroundProcessor, notificationCreate, appMode } = props

  const [selected, setSelected] = useState(0)
  const [showModal, setShowModal] = useState(false)

  const [veoliaOfficers, setVeoliaOfficers] = useState(null)
  const [nwecOfficers, setNwecOfficers] = useState(null)
  const [holbaOfficers, setHolbaOfficers] = useState(null)


  const [editUser, setEditUser] = useState(null)
  const [refresh, setRefresh] = useState(false)

  const [newUser, setNewUser] = useState({
    username: null,
    defaultGroupName: null,
    email: null,
    name: null,
    action: "NEW_USER"
  })

  const [disabled, setDisabled] = useState(true)

  const handleSelect = (e) => {

    setSelected(e.selected)
  }

  const userGroupFetch = async (user) => {
    const userGroups = await fetchUserGroups(user)
    const groups = userGroups.data.groups
    return groups
  }

  useEffect(async () => {
    setAppBarTitle("BIDS Officer Nomination")

    backgroundProcessor?.add()

    setDisabled(true)

    let adminUsers = await fetchAdminUsers()

    const veoliaAdmins = []
    const nwecAdmins = []
    const holbaAdmins = []
 
    for (const user of adminUsers.data.users) {
      user.details = {
        username: user.Username,
        groups: [],
        email: null,
        name: null,
        updated: false,
        mainGroup: null,
      }

      user.Attributes.forEach((att) => {
        if (att.Name === "email") {
          user.details.email = att.Value
        }
        if (att.Name === "given_name") {
          user.details.name = att.Value + " "
        }
        if (att.Name === "family_name") {
          user.details.name = user.details.name + att.Value
        }
        if( att.Name === 'name'){
          if(att.Value !== null){
            user.details.name = att.Value
          }
        }
      })

      const groups = await userGroupFetch(user.Username)

      user.details.groups = groups

      groups.forEach((group) => {
        if (group.GroupName === "VeoliaAdmin") {
          user.details.mainGroup = "VeoliaAdmin"
          veoliaAdmins.push(user)
        } else if(group.GroupName === "NWECAdmin") {
          user.details.mainGroup = "NWECAdmin"
          nwecAdmins.push(user)
        }else if(group.GroupName === "HOLBAAdmin") {
          user.details.mainGroup = "HOLBAAdmin"
          holbaAdmins.push(user)
        }
      })

    }
    setVeoliaOfficers(veoliaAdmins)
    setHolbaOfficers(holbaAdmins)
    setNwecOfficers(nwecAdmins)
    setDisabled(false)
    backgroundProcessor?.remove()
  }, [refresh])

  const newUserDetails = async (event) => {
    const newValue = event.value

    const user = newUser

    user[event.target.props.id] = newValue

    if(event.target.props.id === 'email'){
      user["username"] = newValue
    }

    setNewUser(user)

    //CLEAR ON SUBMIT
  }

  const newUserSubmit = async (event, defaultGroup) => {


    backgroundProcessor?.add()

    const newUserSubmission = newUser

    newUserSubmission.defaultGroupName = defaultGroup

    try {
      const officerSubmission = await submitOfficers(newUserSubmission)
      notificationCreate({
        severity: "success",
        message: "Account Created Succesfully",
      })
      console.log(officerSubmission)
    } catch (error) {
      console.log("ERROR - " + error)
      notificationCreate({
        severity: "error",
        message: "Error - Please Try Again",
      })
    }

    backgroundProcessor?.remove()
  }

  const deleteUserSubmit = async (event) => {
    backgroundProcessor?.add()

    const deleteUser = {
      email: editUser.details.email,
      defaultGroupName: editUser.details.mainGroup,
      action: "DELETE",
      name: editUser.details.name,
      username: editUser.Username
    }

    try {

      const deleteUserSubmission = await submitOfficers(deleteUser)
      setShowModal(!showModal)
      notificationCreate({
        severity: "success",
        message: "Account Deleted Succesfully",
      })
      setRefresh(!refresh)
      console.log(deleteUserSubmission)
    } catch (error) {
      console.log("ERROR - " + error)
      notificationCreate({
        severity: "error",
        message: "Error - Please Try Again",
      })
    }

    backgroundProcessor?.remove()

  }

  const modalHandler = async (event, item) => {
    setEditUser(item)
    setShowModal(!showModal)
  }

  return (
    <>
      <Grid
        container
        direction="column"
        alignItems="center"
        style={{ paddingBottom: "1rem", backgroundColor: "lightgrey" }}
      >
        <Grid
          container
          item
          direction="column"
          alignItems="center"
          style={{ paddingBottom: "1rem", paddingTop: "2rem" }}
        >
          <Grid item>
            <h1>BIDS App - BIDS Officer Nomination</h1>
          </Grid>
        </Grid>
        <Grid container item direction="column" style={{ maxWidth: "95vw" }}>
          <Paper elevation={3} className="home-container">
            <Grid container item direction="column">
              <Grid item style={{ marginBottom: "0.2rem", padding: "1rem" }}>
                <h4>
                  Use this form to create new admin users and BIDs Officers so they
                  are able to manage access requests, and user access to the BIDs app
                </h4>
                <h4>
                  Officers added will not show up until they have logged in for the first time
                </h4>
              </Grid>
              <Grid item>
              {!disabled && (
                <TabStrip selected={selected} onSelect={handleSelect}>
                      
                      {appMode === "Veolia" && (
                      <TabStripTab title="Veolia">
                      <Form
                        {...props}
                        adminList={veoliaOfficers}
                        modalHandler={modalHandler}
                        newUserDetails={newUserDetails}
                        newUserSubmit={newUserSubmit}
                        defaultGroup={"VeoliaAdmin"}
                      />
                      
                  </TabStripTab>
                  )}
                  {appMode !== "HOLBA" && (
                    <TabStripTab title="NWEC">
                    <NwecHolbaRegistrationForm
                      {...props}
                      adminList={nwecOfficers}
                      modalHandler={modalHandler}
                      newUserDetails={newUserDetails}
                      newUserSubmit={newUserSubmit}
                      defaultGroup={"NWECAdmin"}
                    />
                  </TabStripTab>
                  )}
                  {appMode !== "NWEC" && (
              <TabStripTab title="HOLBA">
                      <NwecHolbaRegistrationForm
                        {...props}
                        adminList={holbaOfficers}
                        modalHandler={modalHandler}
                        newUserDetails={newUserDetails}
                        newUserSubmit={newUserSubmit}
                        defaultGroup={"HOLBAAdmin"}
                      />
                    </TabStripTab>
                    )}    
                  
                </TabStrip>
              )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      {showModal && (
        <Dialog
          title={editUser.details.name}
          onClose={(e) => setShowModal(false)}
          height="32vh"
          width="30vw"
          style={{ border: "1px solid #E95F47" }}
        >
          <Grid container direction="column" padding={2}>
            <Grid item>
              <h4>Name: </h4>
              {editUser.details.name}
            </Grid>
            <Grid item>
              <h4>Email:</h4> {editUser.details.email}
            </Grid>
          </Grid>
          <DialogActionsBar>
            <Button
              style={{ backgroundColor: "#E95F47", color: "white" }}
              onClick={(e) => deleteUserSubmit(e)}
            >
              <i className="fas fa-user-times"> </i> Delete Officer
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}
    </>
  )
}
